import { create } from "zustand";
import { TTSavedVideo } from "../models/video";

type TVideoStore = {
  video: Array<TTSavedVideo>;
  setVideo: (video: TTSavedVideo[]) => void;
};

const useVideoStore = create<TVideoStore>((set) => ({
  video: [],
  setVideo: (payload: TTSavedVideo[]) => {
    set({ video: payload });
  },
}));

export default useVideoStore;
